// extracted by mini-css-extract-plugin
module.exports = {"particulars-content":"_2odeAwsmeqn3rzZ-2TReNv","particulars-h2":"_2-lvk2VB1la8pW58eQrdQI","particulars":"_2yNe1EXpRZnMoITyiDaENO"};